<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-2">
      <div class="section-title mb-2">
        {{ $t("add") }} Tier {{ $t("type") }}
      </div>
      <router-link class="btn-blue" :to="{ name: 'Tier Types' }"
        >Tier {{ $t("type") }} {{ $tc("list", 1) }}</router-link
      >
    </div>

    <div class="white-wrapper" style="padding:10px 20px">
      <div class="row" style="height:55px">
        <div class="col-lg-6 col-xl-4 mb-2">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <!-- @focus="onFocusHandler" -->
              <!-- :required="item.required" -->
              <input
                id="tier_type_name"
                name="tier_type_name"
                v-validate="{ required: 'required', regex: /^[a-zA-Z0-9 ]*$/ }"
                v-model="tier_type_name"
                placeholder="."
                v-b-tooltip.hover
                :title="$t('tier_type_name')"
              />
              <label>{{ $tc("tier_type", 1) }} {{ $t("name") }}</label>
            </div>
            <!--Tooltip :title="$t('tier_type_name')" /-->
          </div>
          <p class="error_message">
            <span v-if="submitted && errors.has('tier_type_name')">{{
              errors.first("tier_type_name")
            }}</span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 mb-2">
          <div class="d-flex align-items-center pt-3">
            <b-form-checkbox
              type="checkbox"
              class="j-checkbox"
              v-model="tier_type_is_active"
              true-value="Y"
              false-value="N"
            />

            <label class="mb-0 mr-3">{{ $t("active") }}</label>
          </div>
        </div>

        <div
          class="text-center"
          style="position:absolute;margin-right:50px;right:0;"
        >
          <button @click.prevent.stop="addTierType()" class="btn-blue">
            {{ $t("save") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";

export default {
  data() {
    return {
      submitted: false,
      tier_type_name: "",
      tier_type_is_active: "Y"
    };
  },
  methods: {
    addTierType() {
      this.submitted = true;
      this.$validator.validate().then(valid => {
        if (valid) {
          // let loader = this.$loading.show();

          // console.log("JSON.stringify :", JSON.stringify(finalObj));
          let payload = {
            tier_type_name: this.tier_type_name,
            tier_type_is_active: this.tier_type_is_active
          };
          MasterService.AddTierType(payload)
            .then(response => {
              const { data } = response;
              // loader.hide();
              if (data && data.status) {
                this.$toasted.show(data.message);

                this.$router.push({
                  path: "/master/tier-types"
                });
              } else {
                this.$toasted.show(data.message);
              }
            })
            .catch(this._CatchError);
        }
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/TierTypeComponents/addTierType.vue